// extracted by mini-css-extract-plugin
export default {"title":"SurveyQuestionsEditor_title__7rvZK","questionType":"SurveyQuestionsEditor_questionType__+q7mg"};